import { API, endpoints } from 'src/api';
import { formatFileResponse } from 'src/features/files';

export const createNewCreations = async ({ lessonSlug }) => {
  const { createNewCreations } = endpoints;
  createNewCreations.lessonSlug = lessonSlug;
  const response = await API.get(createNewCreations.url);
  if (response.data?.data) {
    return response.data.data;
  }
  return null;
};

export const createNewCreationsFiles = async ({
  lessonSlug,
  workspace,
}: {
  lessonSlug: any;
  workspace?: string;
}) => {
  let endpoint = `/files/start?lesson=${lessonSlug}`;
  workspace && (endpoint += `&ws=${workspace}`);
  const response = await API.get(endpoint);
  if (response.data?.data) {
    return formatFileResponse(response.data.data);
  }
  return null;
};
